import React from 'react';

interface ButtonProps {
  onClick: () => void;
  children: React.ReactNode;
  disabled?: boolean;
  variant?: 'primary' | 'secondary';
  fullWidth?: boolean;
  className?: string;
}

const Button: React.FC<ButtonProps> = ({ 
  onClick, 
  children, 
  disabled = false,
  variant = 'primary',
  fullWidth = false,
  className = '',
}) => {
  const baseClasses = 'px-6 py-3 text-base font-semibold border-none rounded-lg cursor-pointer transition-all duration-200 min-w-[120px]';
  
  const variantClasses = variant === 'primary' 
    ? 'bg-blue-700 text-white hover:bg-blue-800 hover:-translate-y-0.5 hover:shadow-lg'
    : 'bg-[var(--bg-secondary)] text-[var(--text-primary)] border-2 border-[var(--border-color)] hover:bg-[var(--border-color)] hover:-translate-y-0.5 hover:shadow-lg';
  
  const disabledClasses = disabled 
    ? 'opacity-60 cursor-not-allowed hover:transform-none hover:shadow-none' 
    : 'active:translate-y-0';
  
  const widthClass = fullWidth ? 'w-full' : '';
  
  return (
    <button
      className={`${baseClasses} ${variantClasses} ${disabledClasses} ${widthClass} ${className}`}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

export default Button;
